import React from 'react';

const BusRatesTable = () => {
  const ratesData = [
    
    { seater: "SWIFT DESIRE", mumbai: "4+1", mahabaleshwar: "₹12", specialPermitNumber: "919594917913", driver: "Extra", parking: "Extra" },
    { seater: "AURA", mumbai: "4+1", mahabaleshwar: "₹12", specialPermitNumber: "919594917913", driver: "Extra", parking: "Extra" },
    { seater: "TOYOTA ETIOS", mumbai: "4+1", mahabaleshwar: "₹12", specialPermitNumber: "919594917913", driver: "Extra", parking: "Extra" },
    { seater: "ERITGA", mumbai: "6+1", mahabaleshwar: "₹14", specialPermitNumber: "919594917913", driver: "Extra", parking: "Extra" },
    { seater: "INNOVA", mumbai: "6+1", mahabaleshwar: "₹17", specialPermitNumber: "919594917913", driver: "Extra", parking: "Extra" },
    { seater: "KIA Carens", mumbai: "6+1/7+1", mahabaleshwar: "17/KM & 18/KM", specialPermitNumber: "919594917913", driver: "Extra", parking: "Extra" },
    { seater: "INNOVA CRYSTA", mumbai: "6+1/7+1", mahabaleshwar: "₹19", specialPermitNumber: "919594917913", driver: "Extra", parking: "Extra" },
    { seater: "AUDI", mumbai: "4+1", mahabaleshwar: "ON CALL", specialPermitNumber: "919594917913", driver: "Extra", parking: "Extra" },
    { seater: "Mercedes-Benz", mumbai: "4+1", mahabaleshwar: "ON CALL", specialPermitNumber: "919594917913", driver: "Extra", parking: "Extra" },
    { seater: "BMW / Jaguar", mumbai: "4+1", mahabaleshwar: "ON CALL", specialPermitNumber: "919594917913", driver: "Extra", parking: "Extra" },
    { seater: "TEMPO TRAVELLER", mumbai: "13/17 SEATER", mahabaleshwar: "ON CALL", specialPermitNumber: "919594917913", driver: "Extra", parking: "Extra" },
    { seater: "MINI BUS", mumbai: "20 SEATER", mahabaleshwar: "ON CALL", specialPermitNumber: "919594917913", driver: "Extra", parking: "Extra" },
    { seater: "BUS", mumbai: "32 SEATER", mahabaleshwar: "ON CALL", specialPermitNumber: "919594917913", driver: "Extra", parking: "Extra" },
    
  ];

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    margin: "20px auto",
  };

  const thStyle = {
    backgroundColor: "#0310a8",
    color: "white",
    padding: "8px",
    border: "1px solid white",
    textAlign: "center",
  };

  const tdStyle = {
    padding: "8px",
    border: "1px solid #0310A8",
    textAlign: "center",
    color: "black",
  };

  const trEvenStyle = {
    backgroundColor: "white",
  };

  const handleWhatsAppClick = (number, seater) => {
    console.log(`Opening WhatsApp for ${seater} with number ${number}`);
    const message = `Hi, I would like to enquire about booking rates for ${seater}.`;
    const url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <div className="container p-0">
      <h2 className='pt-4 darkcolorrr'>RATES</h2>
      <div className="table-responsive">
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>Name</th>
              <th style={thStyle}>Seater</th>
              <th style={thStyle}>Per KM</th>
              <th style={thStyle}>Driver Food</th>
              <th style={thStyle}>Toll Parking</th>
              <th style={thStyle}>Book Now</th>
            </tr>
          </thead>
          <tbody>
            {ratesData.map((row, index) => (
              <tr key={index} style={index % 2 === 0 ? trEvenStyle : null}>
                <td style={tdStyle}>{row.seater}</td>
                <td style={tdStyle}>{row.mumbai}</td>
                <td style={tdStyle}>{row.mahabaleshwar}</td>
                <td style={tdStyle}>{row.driver}</td>
                <td style={tdStyle}>{row.parking}</td>
                <td style={tdStyle}>
                  <button
                    onClick={() => handleWhatsAppClick(row.specialPermitNumber, row.seater)}
                    style={{
                      cursor: "pointer",
                      backgroundColor: "#0310a8",
                      padding: "10px",
                      borderRadius: "8px",
                      color: "white",
                    }}
                  >
                    Book Now
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BusRatesTable;
